import reducers from './reducers';
import actions from './actions';

export default {
  reducers: reducers,
  actions: actions
};



// WEBPACK FOOTER //
// ./src/store/modules/onlinesales/index.js